// extracted by mini-css-extract-plugin
export default {"fontFactorRegular":"\"FactorA Regular\",arial,sans-serif","fontFactorMedium":"\"FactorA Medium\",arial,sans-serif","fontFactorBold":"\"FactorA Bold\",arial,sans-serif"};